export default {
  PROFILE: 'profile',
  REWARD: 'reward',
  BADGE: 'badge',
  GROUP: 'groups',
};
